export const VCF_UPLOAD_NOTIFICATION_MESSAGES = {
  FILE_REQUIRED: 'Please select a VCF file before uploading.',
  UPLOAD_STARTED: 'VCF upload started.',
  UPLOAD_FAILED: 'The VCF upload could not be started.',
} as const;
